<template>
  <section
    v-if="pageData"
    class="lead-validation"
  >
    <div class="lead-validation-container">
      <h1
        v-if="_.get(pageData, 'title', '')"
        class="lead-validation__title"
      >
        {{ _.get(pageData, 'title', '') }}
      </h1>
      <form
        class="lead-validation-form"
        @submit.prevent="onAccept(_.get(pageData, 'accept.url', ''))"
      >
        <BaseInput
          v-for="(field, index) in formData"
          :key="index"
          v-model="field.Content"
          required
          maxlength="100"
          :disabled="!field.Editable"
          :label="field.Label"
          :name="field.Name"
          class="lead-validation-form-input"
        />

        <div class="lead-validation-form__buttons">
          <div class="lead-validation-form__buttons-inner">
            <div class="lead-validation-form__buttons-col">
              <BaseButton
                buttonNativeType="submit"
                type="main"
                class="lead-validation-form__btn lead-validation-form__btn_accept"
              >
                {{ _.get(pageData, 'accept.label', '') }}
              </BaseButton>
            </div>
            <div class="lead-validation-form__buttons-col">
              <BaseButton
                buttonNativeType="button"
                type="secondary"
                class="lead-validation-form__btn lead-validation-form__btn_decline"
                @click="onDecline(_.get(pageData, 'decline.url', ''))"
              >
                {{ _.get(pageData, 'decline.label', '') }}
              </BaseButton>
            </div>
          </div>
        </div>
      </form>
    </div>
  </section>
</template>
<script>
  export default {
    name: 'LeadValidation',
    data () {
      return {
        loading: false,
        pageData: null,
        formData: {}
      }
    },

    async beforeCreate () {
      try {
        this.pageData = await this.$store.dispatch('fetchFleetPageData')
        this.formData = _.cloneDeep(this.pageData.fields)
      } catch (error) {
        this.onError(error)
      }
    },

    methods: {
      onError (error) {
        this.$router.push({
          name: 'not-found',
          params: {
            title: _.get(error, 'response.data.id', '') ? _.get(error, 'response.data.id', '') : `${_.get(error, 'response.data.status', '500')} ${_.get(error, 'response.data.name', '')}`,
            description: _.get(error, 'response.data.message', ''),
            buttonText: _.get(error, 'response.data.button', ''),
            goBack: true
          }
        })
      },
      async onAccept (url) {
        this.loading = true

        try {
          const convertFormData = () => {
            const formData = new FormData()
            this.formData.forEach((item, index) => {
              if (item.Editable) {
                formData.append(`fields[${index}][Label]`, item.Label)
                formData.append(`fields[${index}][Name]`, item.Name)
                formData.append(`fields[${index}][Content]`, item.Content)
              }
            })
            return formData
          }
          const { data } = await window.axios({
            method: 'POST',
            url,
            data: convertFormData()
          })

          console.log(data)
          this.$router.push({ name: 'thank-you', params: { title: 'ВАША ЗАЯВКА НА ОТРИМАННЯ КОНСУЛЬТАЦІЇ ЩОДО НАЯВНОГО В УКРАЇНІ АВТОМОБІЛЯ ПРИЙНЯТА' } })
        } catch (error) {
          console.log(`onAccept ${error}`)
          this.onError(error)
        } finally {
          this.loading = false
        }
      },

      async onDecline (url) {
        this.loading = true

        try {
          const { data } = await window.axios({
            method: 'POST',
            url
          })

          console.log(data)
          this.$router.push({ name: 'thank-you', params: { title: 'Дякуємо за відповідь' } })
        } catch (error) {
          console.log(`onAccept ${error}`)
          this.onError(error)
        } finally {
          this.loading = false
        }
      }
    }
  }
</script>
<style lang="scss">
  .lead-validation {
    padding-top: 40px;
    padding-bottom: 100px;

    &-container {
      max-width: 768px;
      padding-right: 15px;
      padding-left: 15px;
      margin: 0 auto;
    }

    &__title {
      //
    }

    &-form {
      &__buttons {
        margin-top: 30px;

        &-inner {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          margin: 0 -15px -20px;
        }

        &-col {
          padding: 0 15px;
          margin-bottom: 20px;

          @include mobile {
            flex: 1 1 100%;
            max-width: 100%;
          }
        }
      }

      .lead-validation-form__btn {
        &_accept,
        &_decline {
          width: 100%;
        }
      }
    }
  }
</style>
